import React from 'react';

interface SuggestionChipsProps {
  suggestions: string[];
  onSuggestionClick: (text: string) => void;
}

/**
 * Renders a series of suggestion chips that users can click to trigger new queries.
 */
const SuggestionChips: React.FC<SuggestionChipsProps> = ({
  suggestions,
  onSuggestionClick,
}) => {
  return (
    <div className="ves-suggestion-chips">
      {suggestions.map((suggestion, idx) => (
        <button
          key={idx}
          className="ves-suggestion-chip"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default SuggestionChips;
